// Vietnamese translations. Key = the English text used in the code (including {placeholders}).
export const VI: Record<string, string> = {
  // ---- general ----
  "(lunch break added)": "(đã cộng giờ nghỉ trưa)",
  "(open chat)": "(mở chat)",
  "(opens a new tab)": "(mở tab mới)",
  ". It is recalculated when staff set each effect’s level.": ". Hạn chót được tính lại khi Staff chọn level cho từng effect.",
  "ADV · Advanced": "ADV · Nâng cao",
  "AI credits": "Credit AI",
  "AI tool": "Công cụ AI",
  "AI tools": "Công cụ AI",
  Accepted: "Đã chấp nhận",
  "Accepted by editor first time": "Editor nhận ngay lần đầu",
  "Account: {name}": "Tài khoản: {name}",
  Active: "Đang dùng",
  "Activity log": "Nhật ký",
  "Add tool": "Thêm công cụ",
  "Add type": "Thêm loại",
  Adds: "Cộng",
  "All events": "Tất cả sự kiện",
  "Ask your leader for the sign-up form.": "Hỏi Leader để lấy form đăng ký.",
  Assign: "Gán",
  "Assign effect": "Gán effect",
  "BS · Basic": "BS · Cơ bản",
  Back: "Quay lại",
  "Back to my workspace": "Về màn hình của tôi",
  "Back to the list": "Quay lại danh sách",
  "Being reworked": "Đang sửa lại",
  Brief: "Yêu cầu",
  Cancel: "Hủy",
  "Change requests from the Feedback button, newest first.": "Yêu cầu sửa gửi từ nút Góp ý, mới nhất ở trên.",
  Chat: "Chat",
  "Chat about {code}": "Chat về đơn {code}",
  "Chat for {code}": "Chat đơn {code}",
  "Check everything before sending. Once sent, the order goes to the staff queue.": "Kiểm tra lại trước khi gửi. Sau khi gửi, đơn vào hàng chờ của Staff.",
  Checklist: "Checklist",
  "Choose staff…": "Chọn Staff…",
  "Clock started": "Bắt đầu tính giờ",
  Close: "Đóng",
  "Close menu": "Đóng menu",
  Code: "Mã",
  "Jobcode": "Jobcode",
  "Coef.": "Hệ số",
  Coefficient: "Hệ số",
  "Coefficient = reviews × {n}.": "Hệ số = số lượt kiểm định × {n}.",
  "Coefficient = sum of level coefficients of effects that passed QC.": "Hệ số = tổng hệ số level của các effect đạt QC.",
  Collapse: "Thu gọn",
  "Context, style, notes per effect…": "Bối cảnh, phong cách, lưu ý cho từng effect…",
  "Control tower": "Điều hành",
  Converted: "Quy đổi",
  "Converted income = coefficient × {price}. Minutes drive the deadline.": "Thu nhập quy đổi = hệ số × {price}. Số phút dùng để tính hạn chót.",
  "Could not load data": "Không tải được dữ liệu",
  Credits: "Credit",
  "Credits must be a number ≥ 0.": "Credit phải là số ≥ 0.",
  "Credits per run": "Credit mỗi lượt",
  "Credits used": "Credit đã dùng",
  Cycle: "Vòng",
  Deadline: "Hạn chót",
  "Default credits for one run; staff record the real credits when they submit.": "Credit mặc định cho 1 lượt chạy; Staff ghi số thực tế khi nộp.",
  "Default level": "Level mặc định",
  "Default minutes per effect (not classified)": "Số phút mặc định / effect (chưa phân loại)",
  "Default tool": "Công cụ mặc định",
  Delivery: "Bàn giao",
  Details: "Chi tiết",
  "Development server · email sign-in": "Máy chủ phát triển · đăng nhập bằng email",
  Disabled: "Đã khóa",
  "Due soon (< {m}m)": "Sắp hạn (< {m} phút)",
  Edit: "Sửa",
  Editor: "Editor",
  "Editors see QC names": "Editor thấy tên QC",
  "Effect assigned": "Đã gán effect",
  "Effect not found.": "Không tìm thấy effect.",
  "Effect taken": "Đã nhận effect",
  "Effect type": "Loại effect",
  "Effect types": "Loại effect",
  "Effect types table": "Bảng loại effect",
  Effects: "Effect",
  "Effects ({n})": "Effect ({n})",
  "Effects passed QC": "Effect đạt QC",
  "Empty = {n} (one run)": "Để trống = {n} (1 lượt)",
  "Estimated deadline": "Hạn chót dự kiến",
  "Event type": "Loại sự kiện",
  "Every effect has an owner": "Mọi effect đã có người nhận",
  "Example: hide the staff column, rename this button, the form needs a phone field.": "Ví dụ: ẩn cột Staff, đổi tên nút này, form cần thêm ô số điện thoại.",
  "Export CSV": "Xuất CSV",
  "Export open items": "Xuất mục chưa xử lý",
  Feedback: "Góp ý",
  "Feedback inbox": "Hộp góp ý",
  "Feedback on this screen": "Góp ý cho màn hình này",
  "Filter by role": "Lọc theo vai trò",
  "Filter by status": "Lọc theo trạng thái",
  "First pass": "Đạt lần đầu",
  Format: "Định dạng",
  From: "Từ ngày",
  "General rules": "Quy tắc chung",
  "Go to my workspace": "Về màn hình của tôi",
  Group: "Nhóm",
  Home: "Trang chủ",
  "How to use {title}": "Hướng dẫn {title}",
  "How to use: {title}": "Hướng dẫn: {title}",
  Image: "Ảnh",
  "In progress ({n})": "Đang chạy ({n})",
  Income: "Quy đổi",
  "Input link": "Link input",
  Instructions: "Mô tả yêu cầu",
  KPI: "KPI",
  "Last 7 days": "7 ngày qua",
  "Last month": "Tháng trước",
  Level: "Level",
  "Levels & coefficients": "Level & hệ số",
  "Levels table": "Bảng level",
  "Load of {name}: {p}%": "Tải của {name}: {p}%",
  Loading: "Đang tải",
  "Lunch ends": "Kết thúc nghỉ trưa",
  "Lunch starts": "Bắt đầu nghỉ trưa",
  Main: "Điều hướng chính",
  "Master data": "Master Data",
  "Master data saved (version {n})": "Đã lưu Master Data (phiên bản {n})",
  "Max effects per person per order": "Số effect tối đa / người / đơn",
  Messages: "Tin nhắn",
  Minutes: "Phút",
  Name: "Họ tên",
  Namecode: "Namecode",
  "Namecode · team": "Namecode · team",
  "New effect": "Effect mới",
  "New order": "Tạo đơn",
  "New tool": "Công cụ mới",
  No: "Không",
  "No (hidden)": "Không (ẩn)",
  "No Namecode available": "Chưa có Namecode",
  "No completed orders yet": "Chưa có đơn hoàn tất",
  "No conversations yet": "Chưa có cuộc trò chuyện",
  "No data": "Chưa có dữ liệu",
  "No effects passed QC in this range": "Chưa có effect đạt QC trong khoảng này",
  "No feedback here": "Chưa có góp ý",
  "No matching events": "Không có sự kiện phù hợp",
  "No messages yet": "Chưa có tin nhắn",
  "No messages yet. Start the conversation about this order.": "Chưa có tin nhắn. Bắt đầu trao đổi về đơn này.",
  "No order matches “{q}”": "Không tìm thấy đơn “{q}”",
  "No orders in progress": "Chưa có đơn đang chạy",
  "No reviews in this range": "Chưa có lượt kiểm định trong khoảng này",
  "No staff registered yet": "Chưa có Staff đăng ký",
  "Nobody here yet": "Chưa có ai",
  None: "Không có",
  Normal: "Bình thường",
  "Not classified": "Chưa phân loại",
  "Not registered yet?": "Chưa đăng ký?",
  "Nothing is waiting for review.": "Không có gì chờ kiểm định.",
  "Nothing waiting for you": "Không có đơn nào chờ bạn",
  "Nothing yet": "Chưa có gì",
  Notifications: "Thông báo",
  "Number of effects": "Số lượng effect",
  "ORDER AI": "ORDER AI",
  "One catalogue used by New order, Take effect and KPI.": "Danh mục duy nhất dùng ở Tạo đơn, Nhận effect và KPI.",
  "One conversation per order.": "Mỗi mã đơn một kênh chat.",
  "One fewer effect": "Bớt 1 effect",
  "One more effect": "Thêm 1 effect",
  "Open menu": "Mở menu",
  "Open output": "Mở output",
  "Open the chat for this order": "Mở chat của đơn này",
  "Open the sign-up form": "Mở form đăng ký",
  Order: "Mã đơn",
  "Order details": "Thông tin đơn",
  "Order {code} accepted": "Đã nghiệm thu đơn {code}",
  "Order {code} sent back for changes": "Đã gửi yêu cầu sửa đơn {code}",
  Orders: "Đơn hàng",
  "Orders on time": "Đơn xong đúng hạn",
  "Orders table": "Bảng đơn hàng",
  "Orders you take part in show up here.": "Các đơn bạn tham gia sẽ hiện ở đây.",
  Output: "Output",
  "Output link": "Link output",
  "Output passed QC. Open it, then accept or send back.": "Output đã qua QC. Mở xem rồi chấp nhận hoặc gửi lại để sửa.",
  "Output submitted to QC": "Đã nộp output cho QC",
  Overdue: "Quá hạn",
  "Overdue {t}": "Quá hạn {t}",
  "Owner, type, level and coefficient from master data.": "Người nhận, loại, level và hệ số theo Master Data.",
  "Owner:": "Người nhận:",
  "Page not found": "Không tìm thấy trang",
  Pass: "Duyệt đạt",
  Passed: "Đạt",
  "Passed QC first time": "Đạt QC lần đầu",
  "Passed. Order {code} is now with the editor.": "Đã duyệt. Đơn {code} chuyển sang Editor nghiệm thu.",
  "People appear after they submit the sign-up form and the sheet syncs.": "Nhân sự sẽ hiện sau khi gửi form đăng ký và sheet được đồng bộ.",
  "Pick an order to start": "Chọn một mã đơn để bắt đầu",
  "Price per coefficient (VND)": "Đơn giá 1 hệ số (VNĐ)",
  Priority: "Ưu tiên",
  "Progress of each effect.": "Tiến độ từng effect.",
  Prompt: "Prompt",
  "Prompt used": "Prompt đã dùng",
  QC: "QC",
  "QC KPI table": "Bảng KPI QC",
  "QC checklist": "Checklist QC",
  "QC coefficient per review": "Hệ số QC mỗi lượt kiểm định",
  "QC passed": "Đạt QC",
  "QC queue": "Hàng chờ QC",
  "QC returned this effect": "QC trả sửa effect này",
  "Quick ranges": "Chọn nhanh",
  "Ready for your review ({n})": "Chờ bạn nghiệm thu ({n})",
  "Reason for returning (required to return)": "Lý do trả sửa (bắt buộc khi trả sửa)",
  "Recently completed": "Hoàn tất gần đây",
  "Record the prompt you used so QC and others can follow it.": "Ghi lại prompt đã dùng để QC và người sau tham khảo.",
  "Register once with the sign-up form, then sign in again (it can take a minute to appear).": "Đăng ký một lần bằng form đăng ký rồi đăng nhập lại (có thể mất khoảng 1 phút để cập nhật).",
  "Registered email": "Email đã đăng ký",
  Requested: "Yêu cầu",
  "Requested effect types": "Loại effect yêu cầu",
  "Requires:": "Cần quyền:",
  "Resubmitted v{n}": "Nộp lại v{n}",
  Return: "Trả sửa",
  Returned: "Trả sửa",
  "Returned:": "Trả sửa:",
  Review: "Kiểm định",
  "Review history": "Lịch sử",
  "Review order": "Kiểm tra đơn",
  "Review saved": "Đã lưu kết quả kiểm định",
  Reviews: "Lượt kiểm định",
  "Sample link": "Link sample",
  Save: "Lưu",
  "Save changes": "Lưu thay đổi",
  "Say what to fix (at least 5 characters).": "Ghi rõ cần sửa gì (tối thiểu 5 ký tự).",
  "Search by order or jobcode": "Tìm theo mã đơn hoặc jobcode",
  "Search name, email, code…": "Tìm tên, email, mã…",
  "Search order or jobcode…": "Tìm mã đơn hoặc jobcode…",
  "Search orders": "Tìm đơn",
  "Search orders by code or jobcode": "Tìm đơn theo mã hoặc jobcode",
  "Search people": "Tìm nhân sự",
  "Search people, orders, details…": "Tìm người, mã đơn, nội dung…",
  "Search the log": "Tìm trong nhật ký",
  See: "Xem",
  "See all": "Xem tất cả",
  "Send back": "Gửi lại để sửa",
  "Send back {code}": "Gửi lại đơn {code} để sửa",
  "Send message": "Gửi tin nhắn",
  "Send order": "Gửi đơn",
  "Settings groups": "Nhóm cấu hình",
  "Show more": "Xem thêm",
  "Showing the latest": "Đang hiện",
  "Showing {a} of {b}": "Hiện {a}/{b}",
  "Sign in": "Đăng nhập",
  "Sign in without Google": "Đăng nhập không qua Google",
  "Sign out": "Đăng xuất",
  Signals: "Tín hiệu",
  "Signing you in…": "Đang đăng nhập…",
  "Skip lunch in deadlines": "Trừ giờ nghỉ trưa khi tính hạn",
  "Skip to main content": "Bỏ qua tới nội dung chính",
  Someone: "Người dùng",
  "Someone else": "người khác",
  "Something went wrong.": "Đã có lỗi xảy ra.",
  "Sorted by deadline. Assign them to staff directly.": "Sắp theo hạn chót. Gán trực tiếp cho Staff.",
  Staff: "Staff",
  "Staff KPI table": "Bảng KPI Staff",
  "Staff coefficient": "Hệ số Staff",
  "Staff coefficient per day": "Hệ số Staff theo ngày",
  "Staff converted income": "Thu nhập quy đổi Staff",
  "Staff load": "Tải Staff",
  "Staff load limit (sum of coefficients in progress)": "Ngưỡng tải Staff (tổng hệ số đang làm)",
  "Start the clock at": "Giờ bắt đầu tính",
  Status: "Trạng thái",
  "Step 1 of 2 · Fill in the order. You’ll review it before sending.": "Bước 1/2 · Nhập thông tin. Bước sau bạn sẽ kiểm tra lại trước khi gửi.",
  Submissions: "Các lần nộp",
  "Submit output (version {n})": "Nộp output (phiên bản {n})",
  "Submit to QC": "Nộp cho QC",
  Submitted: "Đã nộp",
  "Submitted. Waiting for QC.": "Đã nộp, đang chờ QC.",
  "Sum of coefficients in progress / limit {n}": "Tổng hệ số đang làm / ngưỡng {n}",
  Summary: "Tổng quan",
  "Sync now": "Đồng bộ ngay",
  System: "Hệ thống",
  "Take effect": "Nhận effect",
  Team: "Nhân sự",
  "Team of the position": "Team",
  "Team chat": "Chat nội bộ",
  Teams: "Team",
  "Thanks — your feedback was saved": "Cảm ơn — góp ý đã được lưu",
  "The Team question in the sign-up form must use these IDs.": "Câu hỏi Team trong form đăng ký phải dùng đúng các mã này.",
  "The editor asked for changes": "Editor yêu cầu sửa",
  "The link must start with http:// or https://": "Link phải bắt đầu bằng http:// hoặc https://",
  "The order returns to the team for another cycle. Your reason is sent to them.": "Đơn quay lại để sửa ở vòng tiếp theo. Lý do sẽ được gửi tới người xử lý.",
  "The queue is empty": "Hàng chờ trống",
  "This attempt has been logged.": "Lần truy cập này đã được ghi nhật ký.",
  "This effect is no longer waiting for review.": "Effect này không còn chờ kiểm định.",
  "This effect passed QC.": "Effect này đã đạt QC.",
  "This month": "Tháng này",
  "This screen is for developers only.": "Màn hình này chỉ dành cho dev.",
  To: "Đến ngày",
  Today: "Hôm nay",
  "Tool name": "Tên công cụ",
  "Try again": "Thử lại",
  "Type a message": "Nhập tin nhắn",
  "Type a message… (Enter to send)": "Nhập tin nhắn… (Enter để gửi)",
  URGENT: "GẤP",
  "Unassigned effects": "Effect chưa gán",
  "Unassigned effects ({n})": "Effect chưa gán ({n})",
  Undo: "Hoàn tác",
  Unread: "Chưa đọc",
  Urgent: "Gấp",
  "Use the Google account you registered with.": "Dùng tài khoản Google bạn đã đăng ký.",
  "Version {n}. The single source for coefficients, timing, effect types and tools.": "Phiên bản {n}. Nguồn duy nhất cho hệ số, thời gian, loại effect và công cụ.",
  Video: "Video",
  "Waiting for QC": "Chờ QC",
  "Waiting for editor": "Chờ Editor nghiệm thu",
  "What kind of change?": "Loại thay đổi?",
  "What needs to change?": "Cần sửa gì?",
  "What should change?": "Cần thay đổi gì?",
  "Work groups": "Nhóm việc",
  Workbench: "Bàn làm việc",
  Yes: "Có",
  You: "Bạn",
  "You don’t have access to this screen": "Bạn không có quyền mở màn hình này",
  "Your account has no Namecode in the registration sheet. Ask the developer to add it.": "Tài khoản của bạn chưa có Namecode trong sheet đăng ký. Nhờ dev bổ sung.",
  "Your own effect": "Effect của bạn",
  and: "và",
  "coef.": "hệ số",
  "coefficient when it passes QC.": "hệ số khi đạt QC.",
  credits: "credit",
  "e.g. Tone is colder than the sample; effect #2 has a halo around the subject.": "Ví dụ: tone lạnh hơn sample; effect #2 bị viền quanh chủ thể.",
  effects: "effect",
  "effects per order": "effect mỗi đơn",
  "effects to take": "effect chờ nhận",
  "effects · sent": "effect · gửi lúc",
  "just now": "vừa xong",
  "limit reached in this order": "đã đủ effect trong đơn này",
  load: "tải",
  min: "phút",
  "min · coef.": "phút · hệ số",
  "min. Lunch": "phút. Nghỉ trưa",
  more: "khác",
  of: "trong",
  "open order": "xem đơn",
  or: "hoặc",
  "people · last sync": "người · đồng bộ lần cuối",
  registered: "đăng ký",
  requested: "yêu cầu",
  row: "dòng",
  submitted: "nộp",
  "to the order deadline and counts": "vào hạn chót của đơn và tính",
  "{from} to {to} · counted from effects that passed QC · {price} per coefficient": "Từ {from} đến {to} · tính từ effect đạt QC · {price}/hệ số",
  "{name} is working on this effect.": "Effect này do {name} phụ trách.",
  "{n} effects": "{n} effect",
  "{n} effects waiting for review": "{n} effect đang chờ kiểm định",
  "{n} orders": "{n} đơn",
  "{n} unread": "{n} chưa đọc",
  "{n}h ago": "{n} giờ trước",
  "{n}m ago": "{n} phút trước",
  "{open} orders in progress · {done}/{total} effects passed QC · today {coef} coef. ({money})": "{open} đơn đang chạy · {done}/{total} effect đạt QC · hôm nay {coef} hệ số ({money})",
  "{t} left": "Còn {t}",
  "· Taken by:": "· Đã nhận:",
  "· failed:": "· lỗi:",
  "· open order": "· xem đơn",
  "“Due soon” warning (minutes)": "Cảnh báo sắp hạn (phút)",

  // ---- statuses, tabs and filters (translated where they are rendered) ----
  Draft: "Nháp",
  "Waiting for staff": "Chờ nhận việc",
  "In progress": "Đang xử lý",
  "Ready for review": "Chờ nghiệm thu",
  Completed: "Hoàn tất",
  "Not taken": "Chưa có người nhận",
  "Submitted, waiting for QC": "Đã nộp, chờ QC",
  All: "Tất cả",
  Everyone: "Tất cả",
  Editors: "Editor",
  "Staff AI": "Staff AI",
  "Output QC": "Output QC",
  Leaders: "Leader",
  "My work": "Việc của tôi",
  Open: "Mở",
  Done: "Đã xong",
  "Won’t fix": "Không sửa",
  "Change a form": "Sửa form",
  "Show / hide information": "Ẩn / hiện thông tin",
  Wording: "Câu chữ",
  "Something is broken": "Bị lỗi",
  Other: "Khác",

  // ---- permissions ----
  "View all orders": "Xem toàn bộ đơn hàng",
  "View own orders": "Xem đơn của mình",
  "Create orders": "Tạo đơn hàng",
  "Assign effects to staff": "Gán effect cho Staff",
  "Take and work on effects": "Nhận và xử lý effect",
  "Submit output": "Nộp output",
  "View QC queue": "Xem hàng chờ QC",
  "Pass or return output": "Duyệt / trả sửa output",
  "Review own deliveries": "Nghiệm thu đơn của mình",
  "Order chat": "Chat theo đơn",
  "View team & sync users": "Xem nhân sự & đồng bộ",
  "Edit permissions": "Sửa quyền",
  "Edit master data": "Sửa Master Data",
  "View activity log": "Xem nhật ký",
  "View KPI": "Xem KPI",

  // ---- guides ----
  "Your orders at a glance and what needs you now.": "Xem nhanh đơn của bạn và việc cần bạn xử lý.",
  "“Ready for your review” lists orders that passed QC.": "Mục “Chờ bạn nghiệm thu” là các đơn đã qua QC.",
  "Use “New order” to send a new request.": "Bấm “Tạo đơn” để gửi yêu cầu mới.",
  "Click a jobcode to chat about that order without leaving the page.": "Bấm jobcode để chat về đơn đó ngay tại trang.",
  "Create an order in two steps: fill it in, then check it before sending.": "Tạo đơn qua 2 bước: nhập thông tin rồi kiểm tra lại trước khi gửi.",
  "Left: Namecode, jobcode, number of effects, input link.": "Bên trái: Namecode, jobcode, số lượng effect, link input.",
  "Right: effect types, instructions and the estimated deadline (60 min per effect, +1 hour when it crosses the 12:00–13:00 lunch break).": "Bên phải: loại effect, mô tả và hạn chót dự kiến (60 phút/effect, +1 giờ nếu qua giờ nghỉ trưa 12:00–13:00).",
  "Press “Review order”, check everything, then “Send order”.": "Bấm “Kiểm tra đơn”, xem lại rồi bấm “Gửi đơn”.",
  "Orders and deliveries to review.": "Danh sách đơn và việc nghiệm thu.",
  "Filter by status at the top.": "Lọc theo trạng thái ở thanh trên.",
  "Orders ready for review show an output link: open it, then Accept or Send back.": "Đơn chờ nghiệm thu có link output: mở xem rồi Chấp nhận hoặc Gửi lại để sửa.",
  "Sending back needs a reason; the order goes to the next cycle.": "Gửi lại để sửa phải ghi lý do; đơn chuyển sang vòng tiếp theo.",
  "Click a jobcode to open its chat.": "Bấm jobcode để mở chat của đơn.",
  "Everything about one order in one place.": "Toàn bộ thông tin của một đơn ở một chỗ.",
  "Brief, links, deadline and the status of each effect.": "Yêu cầu, link, hạn chót và trạng thái từng effect.",
  "Use the chat button to talk about this order.": "Dùng nút Chat để trao đổi về đơn này.",
  "Effects you are working on and effects nobody has taken yet.": "Effect bạn đang làm và effect chưa có người nhận.",
  "Returned work and urgent orders come first, then by deadline.": "Việc bị trả sửa và đơn gấp lên đầu, sau đó theo hạn chót.",
  "“Take” an effect and choose its type and level (the deadline follows the level).": "Bấm “Nhận” và chọn loại, level cho effect (hạn chót tính theo level).",
  "Each person can take a limited number of effects per order (3 by default).": "Mỗi người nhận tối đa một số effect trong một đơn (mặc định 3).",
  "“Open” goes to the submission page of that effect.": "Bấm “Mở” để tới trang nộp output của effect.",
  "Submit output for one effect.": "Nộp output cho một effect.",
  "Read the brief and any return reason.": "Đọc yêu cầu và lý do trả sửa (nếu có).",
  "Enter the output link, the prompt you used, the tool and credits.": "Nhập link output, prompt đã dùng, công cụ và credit.",
  "Press “Submit to QC”. Every resubmission becomes a new version.": "Bấm “Nộp cho QC”. Mỗi lần nộp lại tạo một phiên bản mới.",
  "Output waiting for quality control.": "Output đang chờ kiểm định.",
  "Urgent orders and the oldest submissions are on top.": "Đơn gấp và bài nộp sớm nhất ở trên cùng.",
  "“Review” opens the checklist; you can only pass when every item is ticked.": "“Kiểm định” mở checklist; chỉ duyệt đạt được khi đã tích đủ.",
  "Review one effect.": "Kiểm định một effect.",
  "Open the output and compare it with the brief.": "Mở output và đối chiếu với yêu cầu.",
  "Tick each checklist item.": "Tích từng mục checklist.",
  "Good → “Pass”. Not good → “Return” with a concrete reason.": "Đạt → “Duyệt đạt”. Chưa đạt → “Trả sửa” kèm lý do cụ thể.",
  "The shift at a glance: bottlenecks, deadlines and staff load, computed live from orders.": "Bức tranh ca trực: điểm nghẽn, hạn chót và tải nhân sự, tính trực tiếp từ đơn hàng.",
  "Signal tiles count the orders that need action; click to see them.": "Các ô tín hiệu đếm số đơn cần xử lý; bấm để xem.",
  "“Unassigned effects” lets you assign staff directly.": "Mục “Effect chưa gán” cho phép gán Staff ngay.",
  "Staff load = sum of coefficients of effects in progress ÷ the load limit in master data.": "Tải Staff = tổng hệ số effect đang làm ÷ ngưỡng tải trong Master Data.",
  "Everyone registered through the sign-up form.": "Tất cả nhân sự đã đăng ký qua form.",
  "People register with the Google Form; new answers sync from the sheet automatically.": "Mọi người đăng ký bằng Google Form; câu trả lời mới tự đồng bộ từ sheet.",
  "This page is the only place to change people: approve, fix or ignore problem rows, add / change / remove positions, lock or unlock. The sheet is never edited by hand.": "Trang này là nơi duy nhất để sửa nhân sự: duyệt, sửa hoặc bỏ qua dòng lỗi, thêm / đổi / xóa vị trí, khóa hoặc mở khóa. Không sửa tay trong sheet.",
  "“Sync now” pulls the sheet immediately; sign-up rows with a problem are listed with Fix / Ignore buttons.": "“Đồng bộ ngay” lấy sheet ngay lập tức; dòng đăng ký bị lỗi hiện kèm nút Sửa / Bỏ qua.",
  "Master data: the single source for coefficients, timing and catalogues.": "Master Data: nguồn duy nhất cho hệ số, thời gian và danh mục.",
  "Edit the tables, then “Save changes”.": "Sửa trong bảng rồi bấm “Lưu thay đổi”.",
  "Coefficient × unit price = converted income; every screen uses this table.": "Hệ số × đơn giá = thu nhập quy đổi; mọi màn hình dùng chung bảng này.",
  "Each save creates a new version and is logged.": "Mỗi lần lưu tạo một phiên bản mới và được ghi nhật ký.",
  "Every important action, with who and when.": "Mọi thao tác quan trọng: ai làm, lúc nào.",
  "Search or filter by event type.": "Tìm hoặc lọc theo loại sự kiện.",
  "Export CSV for records.": "Xuất CSV để lưu trữ.",
  "Output and converted income for a date range, counted from effects that passed QC.": "Sản lượng và thu nhập quy đổi theo khoảng ngày, tính từ effect đạt QC.",
  "Pick dates or a quick range.": "Chọn ngày hoặc khoảng chọn nhanh.",
  "Staff: level coefficient × unit price. QC: reviews × QC coefficient.": "Staff: hệ số level × đơn giá. QC: số lượt kiểm định × hệ số QC.",
  "Export CSV to reconcile.": "Xuất CSV để đối soát.",
  "One conversation per order you take part in.": "Mỗi đơn bạn tham gia có một kênh chat.",
  "The list only shows your orders; the dot marks unread messages.": "Danh sách chỉ gồm đơn của bạn; chấm xanh là tin chưa đọc.",
  "Pick an order to read and reply.": "Chọn một đơn để đọc và trả lời.",
  "Change requests sent from the Feedback button on every screen.": "Yêu cầu sửa gửi từ nút Góp ý trên mọi màn hình.",
  "Each item records the screen, the person and what to change.": "Mỗi mục ghi màn hình, người gửi và nội dung cần sửa.",
  "Set a status as you work through them.": "Cập nhật trạng thái khi xử lý.",
  "“Export open items” downloads a Markdown list for the next round of fixes.": "“Xuất mục chưa xử lý” tải danh sách Markdown cho đợt sửa tiếp theo.",

  // ---- server messages ----
  "Please sign in.": "Vui lòng đăng nhập.",
  "You do not have permission to do this.": "Bạn không có quyền thực hiện thao tác này.",
  "Cannot reach the server. Check your connection and try again.": "Không kết nối được máy chủ. Kiểm tra mạng rồi thử lại.",
  "Google sign-in could not be verified. Please try again.": "Không xác minh được đăng nhập Google. Vui lòng thử lại.",
  "Google sign-in is not configured.": "Chưa cấu hình đăng nhập Google.",
  "Unknown Namecode.": "Namecode không hợp lệ.",
  "You can only pick a Namecode from your team.": "Chỉ chọn được Namecode trong team của bạn.",
  "Pick at least one effect type.": "Chọn ít nhất 1 loại effect.",
  "Input link must start with http:// or https://": "Link input phải bắt đầu bằng http:// hoặc https://",
  "Output link must start with http:// or https://": "Link output phải bắt đầu bằng http:// hoặc https://",
  "Please explain what to fix (at least 10 characters).": "Vui lòng ghi rõ cần sửa gì (tối thiểu 10 ký tự).",
  "Only the order's editor can review it.": "Chỉ Editor của đơn mới được nghiệm thu.",
  "This order is not waiting for review.": "Đơn chưa ở bước nghiệm thu.",
  "Only the person who took this effect can submit it.": "Chỉ người nhận effect mới được nộp output.",
  "You cannot review your own effect.": "Không được tự kiểm định effect của mình.",
  "Tick every checklist item before passing.": "Cần tích đủ checklist trước khi duyệt đạt.",
  "Please give a reason for returning.": "Vui lòng ghi lý do trả sửa.",
  "You are not part of this order.": "Bạn không tham gia đơn này.",
  "Message is empty.": "Tin nhắn trống.",
  "Please describe what should change.": "Vui lòng mô tả cần thay đổi gì.",
  "Master data was changed by someone else. Reload and try again.": "Master Data vừa được người khác cập nhật. Tải lại rồi sửa lại.",
  "Developer access only.": "Chỉ dành cho dev.",
  "Something went wrong on the server.": "Máy chủ gặp lỗi.",
  "Explain what to fix (at least 10 characters) so the team knows what to change.": "Ghi rõ cần sửa gì (tối thiểu 10 ký tự) để đội biết cần thay đổi gì.",
  "Pick a Namecode.": "Chọn Namecode.",
  "Enter the jobcode (project / video code).": "Nhập jobcode (mã dự án / video).",
  "Between 1 and 30 effects.": "Từ 1 đến 30 effect.",
  "Tell the team what you need (at least 5 characters).": "Mô tả yêu cầu cho đội (tối thiểu 5 ký tự).",
  "Describe what should change.": "Mô tả cần thay đổi gì.",
  "Order {code} sent": "Đã gửi đơn {code}",
  "Sign-in failed.": "Đăng nhập không thành công.",
  "Google sign-in failed to load": "Không tải được đăng nhập Google",
  "Google sign-in failed to load. Check your connection.": "Không tải được đăng nhập Google. Kiểm tra mạng.",
  "Synced {n} people from the sheet": "Đã đồng bộ {n} người từ sheet",
  "Sync failed: {e}": "Đồng bộ lỗi: {e}",
  "Not synced yet": "Chưa đồng bộ",
  "Attach files": "Đính kèm tệp",
  "Attach files (or paste / drop them)": "Đính kèm tệp (hoặc dán / kéo thả vào)",
  "Files to send": "Tệp sẽ gửi",
  "Uploading…": "Đang tải lên…",
  "Upload failed": "Tải lên thất bại",
  "Remove {name}": "Bỏ {name}",
  "Drop files to attach": "Thả tệp để đính kèm",
  "Sent a file": "Đã gửi tệp",
  "Up to {n} files per message.": "Tối đa {n} tệp mỗi lần gửi.",
  "{name}: this file type is not allowed.": "{name}: loại tệp không được hỗ trợ.",
  "{name}: larger than {n} MB.": "{name}: lớn hơn {n} MB.",
  "Attach screenshots or files — or paste an image with Ctrl+V.": "Đính kèm ảnh chụp màn hình hoặc tệp — hoặc dán ảnh bằng Ctrl+V.",
  "This file type is not allowed. Use images, PDF, text, Word or Excel files.": "Loại tệp không được hỗ trợ. Dùng ảnh, PDF, văn bản, Word hoặc Excel.",
  "The file is empty.": "Tệp rỗng.",
  "The file is too large.": "Tệp quá lớn.",
  "The file content does not match its type.": "Nội dung tệp không khớp với loại tệp.",
  "Invalid attachment.": "Tệp đính kèm không hợp lệ.",
  "Up to 6 files per message.": "Tối đa 6 tệp mỗi lần gửi.",
  "Message anyone on the team, or talk about a specific order.": "Nhắn tin trực tiếp cho đồng nghiệp hoặc trao đổi theo từng đơn.",
  Conversations: "Cuộc trò chuyện",
  People: "Nhân sự",
  Online: "Đang online",
  Offline: "Offline",
  "Online now ({n})": "Đang online ({n})",
  "Nobody else is online.": "Chưa có ai khác online.",
  "Nobody else is registered yet": "Chưa có ai khác đăng ký",
  "Chat with {name}": "Chat với {name}",
  "Say hello to {name}.": "Gửi lời chào tới {name}.",
  "Last seen {t}": "Hoạt động {t}",
  "Pick a person or an order to start": "Chọn một người hoặc một đơn để bắt đầu",
  "You cannot message yourself.": "Không thể tự nhắn cho mình.",
  "This person is not available.": "Người này không còn hoạt động.",
  "Messages are limited to 2000 characters.": "Tin nhắn tối đa 2000 ký tự.",
  "Talk to anyone on the team, or about a specific order.": "Trao đổi với bất kỳ ai trong team, hoặc theo từng đơn.",
  "People: message any colleague directly; a green dot means they are online now.": "Nhân sự: nhắn trực tiếp cho đồng nghiệp; chấm xanh là đang online.",
  "Orders: one conversation per order you take part in.": "Đơn hàng: mỗi đơn bạn tham gia có một kênh chat.",
  "The number shows unread messages.": "Con số cho biết tin chưa đọc.",
  "Google sign-in is not configured on this server yet.": "Máy chủ chưa cấu hình đăng nhập Google.",
  Admin: "Quản trị",
  Developer: "Dev",
  "Collapse sidebar": "Thu gọn menu",
  "Expand sidebar": "Mở rộng menu",
  "This account is not registered yet.": "Tài khoản này chưa đăng ký.",
  "This account is disabled. Contact the developer.": "Tài khoản đã bị khóa. Liên hệ dev.",
  "This account has no role yet. Contact the developer.": "Tài khoản chưa có vai trò. Liên hệ dev.",
  "Please sign in again.": "Vui lòng đăng nhập lại.",
  // ---- chat dock ----
  Contacts: "Liên hệ",
  "Contacts, {n} unread": "Liên hệ, {n} chưa đọc",
  "Show contacts": "Hiện danh bạ chat",
  "Hide contacts": "Ẩn danh bạ chat",
  "{n} online": "{n} online",
  "Order chats": "Chat theo đơn",
  Minimize: "Thu nhỏ",
  Restore: "Mở lại",
  "Open in Team chat": "Mở trong Chat nội bộ",
  "Close chat": "Đóng chat",
  // ---- password sign-in / guide ----
  Email: "Email",
  Password: "Mật khẩu",
  "Sign in with password": "Đăng nhập bằng mật khẩu",
  "Wrong email or password.": "Sai email hoặc mật khẩu.",
  "User & tester guide": "Hướng dẫn sử dụng & test",
  "Type a message…": "Nhập tin nhắn…",
  "Chat window: {name}": "Cửa sổ chat: {name}",
  // ---- master data editing ----
  "AI tools table": "Bảng công cụ AI",
  "Add checklist": "Thêm checklist",
  "Add item": "Thêm mục",
  "Add level": "Thêm level",
  "Add team": "Thêm team",
  "Checklist ID": "Mã checklist",
  "Checklist name": "Tên checklist",
  "Default for": "Mặc định cho",
  Delete: "Xóa",
  "Delete {name}": "Xóa {name}",
  "Effect code": "Mã effect",
  "In use": "Đang dùng",
  "Item {n} of {name}": "Mục {n} của {name}",
  "Keep at least one": "Phải giữ ít nhất một mục",
  Kind: "Loại",
  "Level ID": "Mã level",
  "Matches the brief": "Đúng brief",
  "New checklist": "Checklist mới",
  "New level": "Level mới",
  "New team": "Team mới",
  "Not used yet": "Chưa dùng",
  "One catalogue used by New order, Take effect and KPI. Types used by orders can be turned off but not deleted.": "Một danh mục dùng chung cho Tạo đơn, Nhận effect và KPI. Loại đã có đơn dùng thì chỉ tắt được, không xóa được.",
  "QC checklists": "Checklist QC",
  "QC must tick every item before Pass. Each effect type uses one checklist.": "QC phải tick đủ mọi mục mới bấm được Pass. Mỗi loại effect dùng một checklist.",
  "Remove item {n}": "Bỏ mục {n}",
  "Team ID": "Mã team",
  "Teams table": "Bảng team",
  "Tool ID": "Mã công cụ",
  "Unsaved changes": "Có thay đổi chưa lưu",
  "{n} effect type(s)": "{n} loại effect",
  "{n} member(s) or order(s)": "{n} thành viên hoặc đơn",
  "Used by {n} order(s)": "Đang dùng trong {n} đơn",
  "Default level of {n} effect type(s)": "Là level mặc định của {n} loại effect",
  "Used by {n} order(s) — turn it off instead": "Đang dùng trong {n} đơn — hãy tắt thay vì xóa",
  "Default tool of {n} effect type(s)": "Là công cụ mặc định của {n} loại effect",
  "Recorded in {n} order(s)": "Đã ghi trong {n} đơn",
  "Used by {n} effect type(s)": "Đang dùng cho {n} loại effect",
  "Has {n} member(s) or order(s)": "Còn {n} thành viên hoặc đơn",
  // ---- GN, anonymous staff, optional effect types ----
  "Effect type required on New order": "Bắt buộc chọn loại effect khi tạo đơn",
  "Hide Staff real names": "Ẩn tên thật của Staff",
  "On: only the Leader sees Staff names and photos; everyone else sees “Staff 1”, “Staff 2”…": "Bật: chỉ Leader thấy tên và ảnh của Staff; mọi người khác thấy “Staff 1”, “Staff 2”…",
  "Yes (only Leader sees names)": "Có (chỉ Leader thấy tên)",
  "No (everyone sees names)": "Không (mọi người thấy tên)",
  "No (optional)": "Không (không bắt buộc)",
  optional: "không bắt buộc",
  "No type requested — choose one when you take it": "Chưa yêu cầu loại — chọn khi nhận effect",
  "Not specified — staff choose the type": "Không chỉ định — Staff tự chọn loại",
  "no type requested": "chưa yêu cầu loại",
  "View only — you can read this conversation but not reply.": "Chỉ xem — bạn đọc được cuộc trò chuyện nhưng không trả lời được.",
  "User guide": "Hướng dẫn sử dụng",
  "User guide · {role}": "Hướng dẫn sử dụng · {role}",
  "Each screen also has a “?” button next to its title.": "Mỗi màn còn có nút “?” cạnh tiêu đề.",
  "Full guide for testers (all roles)": "Hướng dẫn đầy đủ cho tester (mọi vai trò)",
  // role guides
  "Every order across all teams.": "Toàn bộ đơn của mọi team.",
  "Open an order for its brief, effects and history.": "Mở một đơn để xem brief, effect và lịch sử.",
  "Assign unassigned effects from the Control tower.": "Gán effect chưa có người ở Control tower.",
  "You can accept or send back a delivery on the editor's behalf when needed.": "Khi cần, bạn có thể chấp nhận hoặc trả lại thay Editor.",
  "Every order, view only.": "Toàn bộ đơn, chỉ xem.",
  "Open an order to read its brief, effects and delivery.": "Mở một đơn để đọc brief, effect và kết quả bàn giao.",
  "Use the chat button to read the order's conversation.": "Bấm nút chat để đọc cuộc trò chuyện của đơn.",
  "You cannot change orders or reply in chats.": "Bạn không sửa được đơn và không trả lời chat.",
  "Everything about one order, view only.": "Mọi thông tin về một đơn, chỉ xem.",
  "Use the chat button to read the conversation (view only).": "Bấm nút chat để đọc cuộc trò chuyện (chỉ xem).",
  "Read every order conversation.": "Đọc mọi cuộc trò chuyện theo đơn.",
  "Pick an order on the left to read its chat.": "Chọn một đơn bên trái để đọc chat.",
  "View only: you cannot send messages.": "Chỉ xem: bạn không gửi được tin nhắn.",
  "You send orders and accept the finished work.": "Bạn gửi đơn và nghiệm thu kết quả.",
  "Home shows what needs you now.": "Trang chủ cho biết việc cần bạn xử lý ngay.",
  "“New order”: fill in the brief, press “Review order”, then “Send order”.": "“New order”: điền brief, bấm “Review order”, rồi “Send order”.",
  "Orders: open delivered output, then Accept or Send back with a reason.": "Orders: mở output đã bàn giao, rồi Chấp nhận hoặc Trả lại kèm lý do.",
  "Chat: click a jobcode, or a person in the contacts bar.": "Chat: bấm vào jobcode, hoặc một người trong thanh liên hệ.",
  "Feedback (bottom left): tell us what to change on any screen.": "Góp ý (góc trái dưới): ghi điều cần sửa ở bất kỳ màn nào.",
  "You take effects, make them and submit the output.": "Bạn nhận effect, thực hiện và nộp output.",
  "Workbench lists returned and urgent work first.": "Bàn làm việc xếp việc bị trả lại và việc gấp lên đầu.",
  "“Take” an effect and choose its type and level.": "“Take” một effect và chọn loại, level.",
  "“Open” it, enter the output link, prompt, tool and credits, then “Submit to QC”.": "“Open” effect, nhập link output, prompt, công cụ và credit, rồi “Submit to QC”.",
  "Returned work comes back to the top with the reason.": "Việc bị trả lại quay lên đầu kèm lý do.",
  "You check output before it goes to the editor.": "Bạn kiểm output trước khi chuyển cho Editor.",
  "QC queue: urgent and oldest first.": "Hàng chờ QC: việc gấp và cũ nhất lên trước.",
  "“Review”: open the output and compare it with the brief.": "“Review”: mở output và so với brief.",
  "Tick every checklist item to Pass, or Return with a clear reason.": "Tick đủ checklist để Pass, hoặc Return kèm lý do rõ ràng.",
  "You run the shift and keep the settings right.": "Bạn điều hành ca làm và giữ cài đặt đúng.",
  "Control tower: bottlenecks, deadlines, staff load; assign unassigned effects.": "Control tower: điểm nghẽn, hạn chót, tải Staff; gán effect chưa có người.",
  "Team: approve new registrations and check the sheet sync.": "Team: duyệt đăng ký mới và kiểm tra đồng bộ sheet.",
  "Master data: levels, effect types, tools, checklists, teams and rules.": "Master data: level, loại effect, công cụ, checklist, team và quy tắc.",
  "Activity log and KPI: what happened and the converted income.": "Activity log và KPI: những gì đã xảy ra và thu nhập quy đổi.",
  "You review orders and order chats. Everything is view only.": "Bạn kiểm tra đơn và chat theo đơn. Mọi thứ chỉ xem.",
  "Orders: filter and open any order.": "Orders: lọc và mở bất kỳ đơn nào.",
  "Team chat: read the conversation of any order.": "Chat nội bộ: đọc cuộc trò chuyện của bất kỳ đơn nào.",
  "You cannot change orders or send messages.": "Bạn không sửa được đơn và không gửi được tin nhắn.",
  "Feedback (bottom left): report anything that looks wrong.": "Góp ý (góc trái dưới): báo bất cứ điều gì có vẻ sai.",
  // ---- registration approval ----
  "Your registration is waiting for Leader approval.": "Đăng ký của bạn đang chờ Leader duyệt.",
  "Approval emails must be valid email addresses.": "Email người duyệt phải là địa chỉ email hợp lệ.",
  "Approval emails": "Email người duyệt",
  Approve: "Duyệt",
  Reject: "Từ chối",
  "Reject {name}": "Từ chối {name}",
  "Approved — they can sign in now": "Đã duyệt — người này đăng nhập được rồi",
  "Registration rejected": "Đã từ chối đăng ký",
  "Waiting for approval": "Chờ duyệt",
  "Waiting for approval ({n})": "Chờ duyệt ({n})",
  "These people submitted the sign-up form. They can sign in after you approve them.": "Những người này đã điền form đăng ký. Họ đăng nhập được sau khi bạn duyệt.",
  "New sign-ups need Leader approval": "Đăng ký mới cần Leader duyệt",
  "No (anyone in the sheet can sign in)": "Không (ai có trong sheet đều đăng nhập được)",
  "One per line. Empty = every Leader. They get an email with Approve / Reject buttons.": "Mỗi dòng một email. Để trống = mọi Leader. Họ nhận email có nút Duyệt / Từ chối.",
  "Email: ready.": "Email: đã sẵn sàng.",
  "Email: not set up on the server yet.": "Email: chưa cấu hình trên server.",
  "Telegram: ready.": "Telegram: đã sẵn sàng.",
  "Telegram: not set up.": "Telegram: chưa cấu hình.",
  "Links in messages need PUBLIC_URL.": "Link trong tin nhắn cần PUBLIC_URL.",
  // ---- rename, dates ----
  "Change name": "Đổi tên",
  "Change name of {name}": "Đổi tên {name}",
  "Name saved": "Đã lưu tên",
  "shown as {name}": "hiển thị là {name}",
  "Name shown to others (optional)": "Tên hiển thị cho người khác (không bắt buộc)",
  "Replaces the name from the sign-up sheet in the app. The sheet itself is not changed.": "Thay tên lấy từ sheet đăng ký trong app. Sheet không bị sửa.",
  "Used instead of “Staff 1”, “QC 1”… when real names are hidden. Leave empty to keep the number.": "Dùng thay cho “Staff 1”, “QC 1”… khi tên thật đang ẩn. Để trống để giữ số thứ tự.",
  "Name is required (max 80 characters).": "Cần nhập tên (tối đa 80 ký tự).",
  "The name shown to others can have at most 40 characters.": "Tên hiển thị cho người khác tối đa 40 ký tự.",
  "dd/mm/yyyy": "dd/mm/yyyy",
  "Open calendar": "Mở lịch",
  "GN (view only)": "GN (chỉ xem)",
  // ---- test sign-ups ----
  "Create test sign-up": "Tạo đăng ký test",
  "Creates a fake sign-up that goes through the real approval flow. The sheet is not changed.": "Tạo một đăng ký giả đi qua đúng luồng duyệt thật. Sheet không bị thay đổi.",
  "Test sign-up created — check the approval topic on Telegram": "Đã tạo đăng ký test — xem topic duyệt trên Telegram",
  "Test sign-up deleted": "Đã xóa đăng ký test",
  Test: "Test",
  // ---- telegram approvers ----
  "Telegram approvers": "Người duyệt qua Telegram",
  "Telegram usernames allowed to press Approve / Reject, one per line (e.g. @HaoVT_Q). Empty = anyone with the link.": "Username Telegram được bấm Duyệt / Từ chối, mỗi dòng một tên (vd. @HaoVT_Q). Để trống = ai có link cũng duyệt được.",
  "Telegram approvers must be Telegram usernames (5–32 letters, digits or _).": "Người duyệt Telegram phải là username Telegram (5–32 chữ, số hoặc _).",
  // ---- approval channels ----
  "Send approval requests by": "Gửi yêu cầu duyệt qua",
  "Telegram (approve inside the topic)": "Telegram (duyệt ngay trong topic)",
  "Email (Approve / Reject buttons)": "Email (nút Duyệt / Từ chối)",
  "One or both. Leaders can always approve on the Team page.": "Chọn một hoặc cả hai. Leader luôn duyệt được trên trang Team.",
  "Pick at least one way to send approval requests (email or Telegram).": "Chọn ít nhất một kênh gửi yêu cầu duyệt (email hoặc Telegram).",
  // ---- people with several positions ----
  "Add person": "Thêm người",
  "Add position": "Thêm vị trí",
  "Change position": "Sửa vị trí",
  "Change {role} position of {name}": "Sửa vị trí {role} của {name}",
  "Each Namecode belongs to one person; one person can have several.": "Mỗi Namecode thuộc về một người; một người có thể có nhiều Namecode.",
  "Each sign-up (a new person, or a new position for someone already here) starts working after you approve it.": "Mỗi đăng ký (người mới, hoặc vị trí mới cho người đã có) chỉ có hiệu lực sau khi bạn duyệt.",
  "Employee code": "Mã nhân viên",
  "For someone who cannot use the sign-up form. They sign in with this email.": "Dành cho người không dùng được form đăng ký. Người này đăng nhập bằng email dưới đây.",
  "Full name": "Họ và tên",
  "Leader changes are copied to the sheet tab “App edits”.": "Thay đổi của Leader được ghi sang tab “App edits” trong sheet.",
  "Leader changes are not copied to the sheet: {e}": "Thay đổi của Leader chưa ghi được sang sheet: {e}",
  "New person": "Người mới",
  "New position": "Vị trí mới",
  "No team": "Chưa có team",
  Remove: "Xóa",
  "Remove person": "Xóa người",
  "Remove position": "Xóa vị trí",
  "Remove {role} position of {name}": "Xóa vị trí {role} của {name}",
  Removed: "Đã xóa",
  Role: "Vai trò",
  Saved: "Đã lưu",
  "The sign-up sheet is not changed; the change is kept in the app and listed in the sheet tab “App edits” when allowed.": "Sheet đăng ký không bị sửa; thay đổi được lưu trong app và liệt kê ở tab “App edits” của sheet (nếu được cấp quyền ghi).",
  "You hold several positions; each one is explained below.": "Bạn đảm nhận nhiều vị trí; từng vị trí được hướng dẫn bên dưới.",
  "added by Leader": "Leader thêm",
  "form · {email}": "form · {email}",
  test: "test",
  "{name} ({code}) will no longer be able to sign in. Orders and chats they worked on stay.": "{name} ({code}) sẽ không đăng nhập được nữa. Đơn hàng và chat đã làm vẫn được giữ.",
  "{name} will lose the {role} position ({team}).": "{name} sẽ mất vị trí {role} ({team}).",
  "This email already belongs to employee code": "Email này đã thuộc mã nhân viên",
  "This is the only position of this person. Remove the person instead.": "Đây là vị trí duy nhất của người này. Hãy xóa người thay vì xóa vị trí.",
  "This person already has that position.": "Người này đã có vị trí đó.",
  "Pick a team for this position.": "Chọn team cho vị trí này.",
  "Enter a valid employee code.": "Nhập mã nhân viên hợp lệ.",
  "Enter a valid email.": "Nhập email hợp lệ.",
  "You cannot remove yourself.": "Bạn không thể tự xóa mình.",
  "This request was already decided.": "Yêu cầu này đã được xử lý.",
  "This request no longer exists.": "Yêu cầu này không còn nữa.",
  "View only (GN)": "Chỉ xem (GN)",
  "View-only teams only take the GN (view only) role.": "Team chỉ xem chỉ nhận vai trò GN (chỉ xem).",
  "On: only Leaders and the Admin vận hành team see Staff names and photos; everyone else sees “Staff 1”, “Staff 2”…": "Bật: chỉ Leader và team Admin vận hành thấy tên, ảnh của Staff; mọi người khác thấy “Staff 1”, “Staff 2”…",
  "You cannot review your own order.": "Bạn không được QC đơn do chính mình tạo.",
  "Important about the deadline:": "Lưu ý quan trọng về deadline:",
  "this is only an estimated deadline based on the number of effects. It changes after Staff classify each effect (effect name and level). Editors should follow the real deadline after classification to know the AI timing and inform Sales. (The real deadline is the one after the effects are classified.)": "Deadline khi editor điền số lượng effect chỉ là deadline dự kiến. Deadline sẽ có thay đổi sau khi staff phân loại effect (theo Tên effect & Level cụ thể). Editor cần follow Deadline thực tế sau phân loại để nắm bắt thời gian có AI và báo sale. (Deadline thực tế sẽ là deadline sau khi phân loại effect).",
  "Sort by": "Sắp xếp",
  "Priority (returned, urgent, deadline)": "Ưu tiên (bị trả lại, gấp, deadline)",
  "Deadline (soonest first)": "Deadline (gần nhất trước)",
  "Order time (newest first)": "Thời gian order (mới nhất trước)",
  "Order time (oldest first)": "Thời gian order (cũ nhất trước)",
  "Jobcode (A–Z)": "Jobcode (A–Z)",
  "Insert emoji": "Chèn emoji",
  "Emoji could not load.": "Không tải được emoji.",
  "Pick the emoji for the send button": "Chọn emoji cho nút gửi",
  "Quick-send emoji:": "Emoji gửi nhanh:",
  "Change quick-send emoji": "Đổi emoji gửi nhanh",
  "Send {emoji}": "Gửi {emoji}",
  "Open in new tab": "Mở trong tab mới",
  "Whose orders": "Đơn của ai",
  "My orders": "Đơn của tôi",
  "All orders": "Tất cả đơn",
  "Only an editor can review this order.": "Chỉ Editor mới nghiệm thu được đơn này.",
  "by {name}": "bởi {name}",
  "by the order's editor": "bởi editor của đơn",
  "on behalf of the editor": "nghiệm thu hộ",
  "Sent back": "Đã trả lại",
  "Any QC can take it, or send it to one QC only.": "QC nào cũng nhận được, hoặc gửi riêng cho một QC.",
  "Any QC (free)": "QC tự do (ai cũng nhận)",
  "Pick a QC from the list.": "Chọn QC trong danh sách.",
  "You cannot pick yourself as QC.": "Không thể chọn chính mình làm QC.",
  "This effect was sent to another QC.": "Effect này đã được gửi cho QC khác.",
  "Tick all": "Chọn tất cả",
  "Search order, jobcode or name…": "Tìm mã đơn, jobcode hoặc tên…",
  "Ordered from": "Ngày order từ",
  "to": "đến",
  "Needs attention first": "Cần xử lý trước",
  "Deadline (soonest)": "Deadline (gần nhất)",
  "Order time (newest)": "Thời gian order (mới nhất)",
  "Order time (oldest)": "Thời gian order (cũ nhất)",
  "Clear filters": "Xoá bộ lọc",
  "Your registration was not approved.": "Đăng ký của bạn chưa được duyệt (bị từ chối).",
  "Fix your answers in the form and send it again, or send the same request again.": "Sửa câu trả lời trong form rồi gửi lại, hoặc gửi lại yêu cầu như cũ.",
  "Wrong answer? Edit it in the form. Waiting too long? Send the request again.": "Điền sai? Bấm Chỉnh sửa để sửa trong form. Chờ lâu? Bấm Gửi lại để nhắc người duyệt.",
  "Send again": "Gửi lại",
  "Sent again. The approvers have been notified.": "Đã gửi lại. Người duyệt đã được báo.",
  "Already sent. Please wait a few minutes before sending again.": "Đã gửi rồi. Vui lòng chờ vài phút rồi gửi lại.",
  "Sign in with Google again, then try once more.": "Đăng nhập Google lại rồi thử lần nữa.",
  "This sign-up does not need approval any more. Sign in again.": "Đăng ký này không cần duyệt nữa. Hãy đăng nhập lại.",
  "Edit sign-up": "Chỉnh sửa",
  "{n} effect type(s) now default to {other}.": "{n} loại effect đã chuyển level mặc định sang {other}.",
  // ---- feedback 27–28/10 ----
  "Open image": "Mở ảnh",
  "How to make this effect": "Quy trình làm effect",
  "Effect sample": "Sample của effect",
  "Filter by code": "Lọc theo code",
  "Filter by order, jobcode, type or staff…": "Lọc theo mã đơn, jobcode, loại effect hoặc Staff…",
  "No effect matches “{q}”": "Không có effect nào khớp “{q}”",
  "No accepted codes yet": "Chưa có code nào được editor chấp nhận",
  "Time / deadline (minutes)": "Thời gian / deadline (phút)",
  "Converted income = coefficient × {price} (0.1 = {tenth}). Minutes drive the deadline.": "Quy đổi = hệ số × {price} (0.1 = {tenth}). Số phút dùng để tính deadline.",
  "Effect name": "Tên effect",
  Sample: "Sample",
  "How to make it": "Quy trình làm effect",
  "Sample for {code} must be a link starting with http:// or https://": "Sample của {code} phải là link bắt đầu bằng http:// hoặc https://",
  // ---- feedback 28/10 (2) ----
  "Video checklist": "Checklist video",
  "Image checklist": "Checklist ảnh",
  "QC must tick every item before Pass. Each effect type uses a video checklist (for the output) and an image checklist (for the image output).": "QC phải tích đủ mọi mục mới duyệt đạt. Mỗi loại effect dùng một checklist video (cho output) và một checklist ảnh (cho ảnh output).",
  "Coefficient = sum of level coefficients of effects that passed QC. Credits include every submission in the range, returned ones too.": "Hệ số = tổng hệ số level của các effect đạt QC. Credit tính mọi lần nộp trong khoảng thời gian, kể cả lần bị trả sửa.",
  "Returns": "Số lần trả sửa",
  "Open the order details": "Mở chi tiết order",
  "1 · Order from the editor": "1 · Order chi tiết của Editor",
  "2 · Output": "2 · Output",
  "Video output": "Video output",
  "Image output link": "Link ảnh output",
  "Check the video and the image, then tick every item to pass.": "Kiểm tra cả video và ảnh, tích đủ tất cả mục mới duyệt đạt được.",
  "QC will check the video": "QC sẽ kiểm video",
  "QC will check the image": "QC sẽ kiểm ảnh",
  "Add the image output link (starts with http:// or https://).": "Nhập link ảnh output (bắt đầu bằng http:// hoặc https://).",
  "Image output link is required and must start with http:// or https://": "Link ảnh output là bắt buộc và phải bắt đầu bằng http:// hoặc https://",
  "Name the uploaded files exactly as on the order: {name}. Example: code HAOCT27001 with 2 effects → HAOCT27001_1, HAOCT27001_2.": "Lưu ý khi đặt tên output: tên effect up lên link output phải giống tên trên order — ở đây là {name}. Ví dụ code HAOCT27001 có 2 effect thì đặt HAOCT27001_1, HAOCT27001_2.",
  "Video output, file named {name}.": "Video output, đặt tên file {name}.",
  "Image of the result, file named {name}. QC checks it with the image checklist.": "Ảnh của kết quả, đặt tên file {name}. QC kiểm ảnh này theo checklist ảnh.",
  "Take all effects of {name}": "Nhận tất cả effect của {name}",
  "Choose the type and level of each effect.": "Chọn loại và level cho từng effect.",
  "Take {n} effects": "Nhận {n} effect",
  "Effects taken": "Đã nhận các effect",
  "Returned {n} time(s)": "Trả sửa {n} lần",
  "You already have {n} effects in this order": "Bạn đã nhận {n} effect trong đơn này",
  "Limit reached": "Đã đủ số lượng",
  "Take": "Nhận",
  "View": "Xem",
  "Filter by QC result": "Lọc theo kết quả QC",
  "Taken {taken}/{total}": "Đã nhận {taken}/{total}",
  "Take all ({n})": "Nhận tất cả ({n})",
  "Nothing returned to you": "Không có effect nào bị trả sửa",
  "Nothing submitted yet": "Chưa nộp effect nào",
  "You have nothing in progress": "Bạn chưa có việc nào đang làm",
  "Every effect has been taken": "Mọi effect đều đã có người nhận",
  "Video code, e.g. HTOCT29001": "Mã video, ví dụ HTOCT29001",
  "Leave empty, no need to fill in": "Để trống, không cần điền",
  ", lunch break added": ", đã cộng giờ nghỉ trưa",
  "{n} × {min} min. Lunch {from}–{to}: this order crosses lunch, so 1 hour is added.": "{n} × {min} phút. Nghỉ trưa {from}–{to}: đơn này qua giờ nghỉ trưa nên được cộng thêm 1 giờ.",
  "{n} × {min} min. Lunch {from}–{to}: this order does not cross lunch.": "{n} × {min} phút. Nghỉ trưa {from}–{to}: đơn này không qua giờ nghỉ trưa.",
  "Notifications, {n} unread": "Thông báo, {n} chưa đọc",
  Accept: "Chấp nhận",
  "Accept output": "Chấp nhận output",
  // ---- feedback 29/10 ----
  "Shared output folder of the code": "Folder output chung của code",
  "Open the shared output folder of the code to upload your output.": "Mở file ở Folder output chung của code để up output.",
  "First to submit: make one folder for the whole code {code}, upload into it and paste its link here. The editor opens only this folder.": "Bạn nộp đầu tiên: tạo 1 folder cho cả code {code}, up file vào đó rồi dán link folder vào đây. Editor chỉ cần mở folder này.",
  "Add the shared output folder of this code (starts with http:// or https://).": "Nhập link folder output chung của code (bắt đầu bằng http:// hoặc https://).",
  "The shared output folder of the code is required and must start with http:// or https://": "Folder output chung của code là bắt buộc và phải bắt đầu bằng http:// hoặc https://",
  "Open output folder": "Mở folder output",
  "Link type": "Loại link",
  "Mail type": "Loại mail",
  "Choose…": "Chọn…",
  "Pick the link type.": "Chọn loại link.",
  "Pick the mail type.": "Chọn loại mail.",
  "Pick the link type (Dropbox or Drive).": "Chọn loại link (Dropbox hoặc Drive).",
  "Link type · mail": "Loại link · mail",
  "Video output, file named {name}. This code has 1 effect, so no shared folder is needed.": "Video output, đặt tên file {name}. Code chỉ có 1 effect nên không cần folder chung.",
  "{n} sign-up rows need attention": "{n} dòng đăng ký cần xử lý",
  "Fix or ignore them here. The sheet is never edited: every change to people is made on this page.": "Sửa hoặc bỏ qua ngay tại đây. Không sửa tay trong sheet: mọi thay đổi về nhân sự chỉ làm trên trang này.",
  "Fix row": "Sửa dòng",
  "Ignore row": "Bỏ qua dòng",
  "Unlock {name}": "Mở khóa {name}",
  "Lock {name}": "Khóa {name}",
  "Unlock": "Mở khóa",
  "Lock": "Khóa",
  "Fix sign-up row": "Sửa dòng đăng ký",
  "The corrected answer is kept in the app (the sheet is not changed) and waits for your approval like any sign-up.": "Câu trả lời đã sửa được lưu trong app (sheet không bị sửa) và chờ duyệt như mọi đăng ký khác.",
  "{name} ({code}) cannot sign in until unlocked. Their positions stay.": "{name} ({code}) không đăng nhập được cho tới khi mở khóa. Các vị trí vẫn được giữ.",
  "{name} ({code}) can sign in again.": "{name} ({code}) sẽ đăng nhập lại được.",
  "Reason (shown to them)": "Lý do (người đó sẽ thấy)",
  "e.g. Left the company": "vd: Đã nghỉ việc",
  "This answer will not count any more. The sheet is not changed; the person can send the form again.": "Câu trả lời này sẽ không được tính nữa. Sheet không bị sửa; người đó có thể gửi lại form.",
  "This email already belongs to employee code {a}": "Email này đã thuộc mã nhân viên {a}",
  "Namecode {a} already belongs to employee code {b}": "Namecode {a} đã thuộc mã nhân viên {b}",
  "Unknown role “{a}”": "Vai trò không hợp lệ “{a}”",
  "Unknown team “{a}” (position kept without team)": "Team không hợp lệ “{a}” (vẫn giữ vị trí, chưa có team)",
  "Editor without Namecode: assigned {a}": "Editor chưa có Namecode: đã gán {a}",
  "Name differs from the first registration of {a}; kept “{b}”": "Tên khác lần đăng ký đầu của {a}; giữ tên “{b}”",
  "Invalid email": "Email không hợp lệ",
  "Invalid employee code": "Mã nhân viên không hợp lệ",
  "Missing full name": "Thiếu họ tên",
  "Duplicate submission ignored (first answer is kept)": "Gửi trùng, đã bỏ qua (giữ câu trả lời đầu)",
  "You cannot lock yourself.": "Bạn không thể tự khóa mình.",
  "The built-in account cannot be locked.": "Không thể khóa tài khoản dựng sẵn.",
  "This sign-up row has nothing to fix any more. Sync again.": "Dòng đăng ký này không còn gì cần sửa. Hãy đồng bộ lại.",
  "Pick a valid role (Leader is added on a person, not through the form).": "Chọn vai trò hợp lệ (Leader được thêm trên từng người, không qua form).",
  "Password sign-in": "Đăng nhập bằng mật khẩu",
  "Set password of {name}": "Đặt mật khẩu cho {name}",
  "Set password": "Đặt mật khẩu",
  "Password (optional)": "Mật khẩu (không bắt buộc)",
  "At least 6 characters. They sign in with this email + password; leave empty for Google sign-in only.": "Tối thiểu 6 ký tự. Người này đăng nhập bằng email + mật khẩu này; để trống nếu chỉ đăng nhập bằng Google.",
  "New password": "Mật khẩu mới",
  "Replaces the current password. Leave empty and save to remove it (Google sign-in only).": "Thay mật khẩu hiện tại. Để trống rồi Lưu để xóa mật khẩu (chỉ đăng nhập bằng Google).",
  "At least 6 characters. They sign in at the login page with {email} + this password.": "Tối thiểu 6 ký tự. Người này đăng nhập ở trang đăng nhập bằng {email} + mật khẩu này.",
  "The password needs at least 6 characters.": "Mật khẩu cần tối thiểu 6 ký tự.",
  "The built-in account's password is set on the server.": "Mật khẩu tài khoản dựng sẵn được đặt trên server.",
  "Accepted by editor": "Đạt kiểm định",
  "Nothing was sent to you": "Chưa có effect nào gửi riêng cho bạn",
  "Nothing is waiting for a QC": "Không có effect nào đang chờ QC nhận",
  "You have not returned anything": "Bạn chưa trả sửa effect nào",
  "You have not passed anything yet": "Bạn chưa duyệt đạt effect nào",
  "See {n} effects waiting for a QC": "Xem {n} effect chưa có QC nhận",
  "passed {at}": "duyệt đạt {at}",
  "returned {at}": "trả sửa {at}",
  "Review all ({n})": "Kiểm định tất cả ({n})",
  "Review all": "Kiểm định tất cả",
  "Nothing of this code is waiting for your review": "Code này không còn effect nào chờ bạn kiểm định",
  "Tick all of every effect": "Chọn tất cả của mọi effect",
  "Pass {n}/{total} effects": "Duyệt đạt {n}/{total} effect",
  "Return…": "Trả sửa…",
  "“My work” = effects a staff member sent to you; “Not taken” = effects waiting for any QC; “Returned” and “Completed” = what you returned or passed.": "“Việc của tôi” = effect Staff gửi riêng cho bạn; “Chưa có người nhận” = effect chờ QC bất kỳ; “Trả sửa” và “Hoàn tất” = những effect bạn đã trả sửa hoặc duyệt đạt.",
  "Urgent orders and the oldest submissions are on top, grouped by code.": "Đơn gấp và bài nộp cũ nhất nằm trên cùng, nhóm theo code.",
  "“Review” opens the checklist; you can only pass when every item is ticked. “Review all” checks every effect of one code on one page.": "“Kiểm định” mở checklist; chỉ duyệt đạt được khi đã tích đủ. “Kiểm định tất cả” kiểm mọi effect của một code trên cùng một trang.",
  "Review every effect of one code that is waiting for you.": "Kiểm định mọi effect của một code đang chờ bạn.",
  "Open the shared output folder and each image link.": "Mở folder output chung của code và từng link ảnh.",
  "Tick each effect's checklist (or “Tick all of every effect”).": "Tích checklist của từng effect (hoặc “Chọn tất cả của mọi effect”).",
  "“Pass” passes every fully ticked effect at once. To return one effect, use “Return…” on it and give the reason.": "“Duyệt đạt” duyệt cùng lúc mọi effect đã tích đủ. Muốn trả sửa effect nào thì bấm “Trả sửa…” ở effect đó và ghi lý do.",
  "By month": "Theo tháng",
  "KPI views": "Chế độ xem KPI",
  "Month": "Tháng",
  "Previous month": "Tháng trước",
  "Next month": "Tháng sau",
  "Number of codes": "Số code",
  "Effects by type": "Số lượng theo ef",
  "Total": "Total",
  "Sun": "CN",
  "Mon": "Thứ 2",
  "Tue": "Thứ 3",
  "Wed": "Thứ 4",
  "Thu": "Thứ 5",
  "Fri": "Thứ 6",
  "Sat": "Thứ 7",
  "{month} · coefficient, codes, effects and effect types count on the day the effect passed QC; credits on the day of each submission": "{month} · hệ số, số code, số ef và loại ef tính theo ngày effect đạt QC; credit tính theo ngày nộp",
  "“By month”: one table per measure (coefficient, codes, effects, credits used, effects by type), a row per Staff AI and a column per day. Use the arrows to change month.": "“Theo tháng”: mỗi chỉ số một bảng (hệ số, số code, số ef, credit tiêu hao, số lượng theo ef), mỗi Staff AI một dòng, mỗi ngày một cột. Bấm mũi tên để đổi tháng.",
  "“Summary”: pick dates or a quick range. Staff: level coefficient × unit price. QC: reviews × QC coefficient.": "“Tổng hợp”: chọn ngày hoặc khoảng nhanh. Staff: hệ số level × đơn giá. QC: số lượt kiểm định × hệ số QC.",
  "Purchased resources": "Tài nguyên đã mua",
  "Credits bought for App and Higg.": "Credit đã mua cho App và Higg.",
  "Credits bought for App and Higg (view only).": "Credit đã mua cho App và Higg (chỉ xem).",
  "{n} purchases · {credits} credits in total": "{n} lần mua · tổng {credits} credit",
  "No purchases yet": "Chưa có lần mua nào",
  "Resource name": "Tên tài nguyên",
  "Purchase date": "Ngày mua",
  "Edit purchase": "Sửa lần mua",
  "Add purchase": "Thêm lần mua",
  "Delete purchase": "Xoá lần mua",
  "This purchase will be removed from the list.": "Lần mua này sẽ bị xoá khỏi danh sách.",
  "e.g. In use, Used up": "vd: Đang dùng, Đã hết",
  "Edit {name}": "Sửa {name}",
  "Each tool has its own table: resource name, credits, purchase date and status.": "Mỗi công cụ một bảng riêng: tên tài nguyên, số credit, ngày mua và tình trạng.",
  "Only the Leader adds, edits or deletes. Master data decides whether Staff AI can view this page.": "Chỉ Leader thêm, sửa, xoá. Master data quyết định Staff AI có được xem màn này không.",
  "Staff AI can view Purchased resources": "Staff AI được xem Tài nguyên đã mua",
  "Read only. Only the Leader adds, edits or deletes purchases.": "Chỉ xem. Chỉ Leader thêm, sửa, xoá lần mua.",
  "No (Leader only)": "Không (chỉ Leader)",
  "Yes (view only)": "Có (chỉ xem)",
  "Pick App or Higg.": "Chọn App hoặc Higg.",
  "Resource name is required (max 80 characters).": "Cần nhập tên tài nguyên (tối đa 80 ký tự).",
  "Pick the purchase date.": "Chọn ngày mua.",
  "Resource not found.": "Không tìm thấy tài nguyên.",
  "Deleted": "Đã xoá",
  "Add": "Thêm",
  "Actions": "Thao tác",
  "Effect count": "Số ef",
  "Credits consumed": "Số credit tiêu hao",
  "Staff AI access to Purchased resources": "Quyền của Staff AI ở Tài nguyên đã mua",
  "The Leader can always add, edit and delete purchases.": "Leader luôn được thêm, sửa, xoá lần mua.",
  "View only": "Chỉ xem",
  "View and edit": "Xem và sửa",
  "The Leader adds, edits or deletes. Master data decides whether Staff AI cannot see, can view, or can also edit this page.": "Leader thêm, sửa, xoá. Master data quyết định Staff AI không thấy, chỉ xem, hay được sửa màn này.",
  "Number of effect": "Số effect",
  "Count by effect type": "Số lượng theo effect",
  "Credits bought for each resource.": "Credit đã mua cho từng tài nguyên.",
  "Credits bought for each resource (view only).": "Credit đã mua cho từng tài nguyên (chỉ xem).",
  "One list for every resource: resource name, credits, purchase date and status. Filter by month and by resource; the report beside it follows the same filters.": "Một bảng chung cho mọi tài nguyên: tên tài nguyên, credit, ngày mua, trạng thái. Lọc theo tháng và theo tài nguyên; báo cáo bên cạnh dùng cùng bộ lọc.",
  "Resource names and statuses are choices set in master data. “Export CSV” saves the list and the report.": "Tên tài nguyên và trạng thái là các lựa chọn đặt trong Master data. “Xuất CSV” lưu cả bảng và báo cáo.",
  "All months": "Tất cả tháng",
  "All resources": "Tất cả tài nguyên",
  "Purchases": "Lần mua",
  "Report": "Báo cáo",
  "By status": "Theo trạng thái",
  "Credits by month": "Credit theo tháng",
  "Pick a resource from the list.": "Chọn tài nguyên trong danh sách.",
  "Pick a status from the list.": "Chọn trạng thái trong danh sách.",
  "Resource names (Purchased resources)": "Tên tài nguyên (Tài nguyên đã mua)",
  "Statuses (Purchased resources)": "Trạng thái (Tài nguyên đã mua)",
  "One per line. These are the choices for “Resource name”.": "Mỗi dòng một tên. Đây là các lựa chọn của ô “Tên tài nguyên”.",
  "One per line. These are the choices for “Status”.": "Mỗi dòng một trạng thái. Đây là các lựa chọn của ô “Trạng thái”.",
  "Resource names: at least one, each 1–40 characters, no duplicates.": "Tên tài nguyên: ít nhất một, mỗi tên 1–40 ký tự, không trùng.",
  "Resource statuses: at least one, each 1–40 characters, no duplicates.": "Trạng thái tài nguyên: ít nhất một, mỗi trạng thái 1–40 ký tự, không trùng.",
  "Sample by level": "Sample theo level",
  "Change history": "Lịch sử thay đổi",
  "Orders keep the values they were created with; changes apply to new orders.": "Đơn tạo trước khi đổi giữ số liệu cũ; thay đổi áp dụng cho đơn tạo sau.",
  "No changes recorded yet": "Chưa có thay đổi nào được ghi",
  "Version {n}": "Phiên bản {n}",
  "No change in values": "Không đổi giá trị",
  "Resource names": "Tên tài nguyên",
  "Statuses": "Trạng thái",
  "Add resource": "Thêm tài nguyên",
  "Add status": "Thêm trạng thái",
  "New resource": "Tài nguyên mới",
  "New status": "Trạng thái mới",
  "added": "đã thêm",
  "removed": "đã xoá",
  "Tier": "Bậc",
  "Items": "Các mục",
  "Approval by email": "Duyệt qua email",
  "Approval by Telegram": "Duyệt qua Telegram",
  "Staff AI can edit Purchased resources": "Staff AI được sửa Tài nguyên đã mua",
  "Delete code": "Xoá code",
  "Delete code {code}": "Xoá code {code}",
  "Code {code} deleted": "Đã xoá code {code}",
  "The code disappears from every screen, chat and KPI. It is kept in the database and its number is not reused.": "Code sẽ biến mất khỏi mọi màn hình, chat và KPI. Dữ liệu vẫn lưu trong hệ thống và số code không bị dùng lại.",
  "Delete codes": "Xoá code",
  "Codes not taken": "Code chưa có người nhận",
  "Waiting for QC {n}/{total}": "Chờ kiểm định {n}/{total}",
  "Resubmitted": "Nộp lại",
  "No effect matches the filters": "Không có effect nào khớp bộ lọc",
  "Code {code} restored": "Đã khôi phục code {code}",
  "No deleted codes": "Chưa có code nào bị xoá",
  "Deleted codes": "Code đã xoá",
  "New charge code": "Code tính phí mới",
  "New charge": "Tính phí mới",
  "New charge codes": "Code tính phí mới",
  "Not new charge": "Không tính phí mới",
  "View own KPI": "Xem KPI của mình",
  "Paused · {t} left": "Tạm dừng · còn {t}",
  "Waiting for charge confirmation": "Chờ charge phí",
  "Charged": "Đã charge phí",
  "Charge status": "Charge phí",
  "Charge status saved": "Đã lưu trạng thái tính phí",
  "The deadline is paused until you choose “Charged”.": "Hạn chót tạm dừng cho tới khi chọn “Đã tính phí”.",
  "Only staff working on this code can change its charge status.": "Chỉ Staff đang làm code này mới đổi được trạng thái tính phí.",
  "Waiting for charge": "Chờ charge phí",
  "No charge": "Không tính phí",
  "Waiting for image check": "Chờ check ảnh",
  "Waiting for clarification": "Chờ làm rõ thông tin",
  "Hold": "Hold",
  "Cancelled": "Cancel",
  "Info done": "Done",
  "Cancelled codes": "Code cancel",
  "No cancelled codes": "Không có code cancel",
  "Charge: editor ordered wrong": "Tính phí: editor order sai yêu cầu",
  "Changes saved": "Đã lưu thay đổi",
  "Job type": "Loại job",
  "Info status": "Trạng thái thông tin",
  "Hand over code": "Bàn giao code",
  "Hand over": "Bàn giao",
  "Note": "Ghi chú",
  "Edit submission (version {n})": "Sửa bài đã nộp (phiên bản {n})",
  "Editable until QC passes or returns it.": "Sửa được tới khi QC duyệt đạt hoặc trả sửa.",
  "Charge status of {code}": "Charge phí của {code}",
  "Info status saved": "Đã lưu trạng thái thông tin",
  "Info status of {code}": "Trạng thái thông tin của {code}",
  "Cancel code": "Cancel code",
  "The code moves to Cancelled and has no deadline.": "Code chuyển sang mục Code cancel, không tính hạn chót.",
  "Job type saved, deadline recalculated": "Đã đổi loại job, hạn chót đã tính lại",
  "Job type of {name}": "Loại job của {name}",
  "Code handed over": "Đã bàn giao code",
  "Shift": "Ca",
  "Morning shift": "Ca sáng",
  "Evening shift": "Ca tối",
  "Where the code stands": "Code đang tới đâu",
  "At least 5 characters.": "Ít nhất 5 ký tự.",
  "Handed over · {shift}": "Bàn giao · {shift}",
  "Codes": "Code",
  "Status · deadline": "Trạng thái · hạn chót",
  "One row per code; a code with several of your effects opens to show each one.": "Mỗi code một dòng; code có nhiều effect của bạn thì bấm vào để xem từng effect.",
  "Charge and info status: every choice but “Charged”, “No charge” and “Done” pauses the deadline. “Cancel” moves the code to Cancelled codes.": "Charge phí và trạng thái thông tin: mọi lựa chọn trừ “Đã charge phí”, “Không tính phí” và “Done” đều dừng hạn chót. “Cancel” chuyển code sang mục Code cancel.",
  "A paused code can be handed over to the morning or evening shift; it goes back to Not taken with your note.": "Code đang tạm dừng có thể bàn giao cho ca sáng hoặc ca tối; code về mục Chưa có người nhận kèm ghi chú của bạn.",
  "Unknown level.": "Loại job không hợp lệ.",
  "This order is already accepted.": "Đơn này đã được nghiệm thu.",
  "Add a note for Other.": "Ghi chú cho lựa chọn Khác.",
  "Pick the shift.": "Chọn ca.",
  "Write where the code stands (at least 5 characters).": "Ghi code đang tới đâu (ít nhất 5 ký tự).",
  "Only a paused code can be handed over (waiting for the charge, the image check, clarification or on hold).": "Chỉ bàn giao được code đang tạm dừng (chờ charge phí, chờ check ảnh, chờ làm rõ thông tin, hold).",
  "You have no unfinished effect in this code.": "Bạn không còn effect chưa xong trong code này.",
  "QC has already reviewed this effect; it can no longer be changed.": "QC đã duyệt effect này, không sửa được nữa.",
  "The job type can only change while the effect is being worked on.": "Chỉ đổi được loại job khi effect đang làm.",
  "Only the person who took this effect can change its job type.": "Chỉ người nhận effect mới đổi được loại job.",
  "The editor has not sent this code back.": "Editor chưa trả sửa code này.",
  "Only staff working on this code can change its info status.": "Chỉ Staff đang làm code này mới đổi được trạng thái thông tin.",
};
